import { getJson } from "./client";

// Per-document schema of records that land in paim search-environment
// indexes (and equivalently in the NDJSON exports). Source-of-truth on
// the operator lives in src/paim/operator/dataset_schema.py; this
// client surfaces it through /api/v1/schema so the Schema Reference
// page renders the same field list that the handoff doc lists.

export type RecordUnit = "program" | "page";

export interface SchemaField {
  name: string;
  type: string;
  description: string;
  // Which record_unit(s) this field appears on. Sorted alphabetically
  // by the server.
  units: RecordUnit[];
}

export interface SchemaResponse {
  // The full superset across both record units.
  fields: SchemaField[];
  // Subsets, ready-rendered: fields that appear on per-page records,
  // and fields that appear on per-program (combined) records.
  page: SchemaField[];
  program: SchemaField[];
}

export function getSchema(): Promise<SchemaResponse> {
  return getJson<SchemaResponse>("/api/v1/schema");
}
